import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import {
  IconButton,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import { Fragment, useState } from "react";
import { useAppSelector } from "../../app/hooks";
import { ContentKey } from "../talentProfile/TalentDetails";
import { FormattedWorkHistory } from "./TalentWorkHistory";
import WorkTitleCollapsibleRows from "./WorkHistoryCollapsibleRows";
import {
  WorkHistoriesCount,
  WorkTitleContainer,
  WorkTitleTableCell,
} from "./styles";
import { getDateRange } from "./workHistoryTableHelpers";

type Props = {
  data: FormattedWorkHistory[];
  handleOpenEditModal: (content: ContentKey, id?: string) => void;
  handleDelete: (id: string) => void;
  canEdit: boolean;
};

const WorkHistoryTableRows = ({
  data,
  handleOpenEditModal,
  handleDelete,
  canEdit,
}: Props) => {
  const [open, setOpen] = useState<{ id: string; show: boolean }>({
    id: "",
    show: false,
  });

  const translatedWorkTitles = useAppSelector(
    (state) => state.localized.workTitle,
  );

  const getWorkTitle = (workHistory: FormattedWorkHistory) => {
    let workTitle = "";

    if (workHistory.workTitleName) {
      workTitle = workHistory.workTitleName;
    }
    if (workHistory.workTitleId) {
      workTitle =
        translatedWorkTitles[workHistory.workTitleId] || workHistory.workTitleName || "";
    }

    const workHistoriesCount = workHistory.workLocations.length;
    const showWorkHistoriesCount = workHistoriesCount > 1;
    const eezyWorkColor = "inherit";
    const otherWorkColor = "rgba(137, 95, 223, 0.9)";

    return (
      <WorkTitleContainer>
        <Typography
          sx={{
            color: workHistory.isEezyWork ? eezyWorkColor : otherWorkColor,
            fontWeight: 600,
          }}
        >
          {workTitle}
        </Typography>
        {showWorkHistoriesCount && (
          <WorkHistoriesCount>{workHistoriesCount}</WorkHistoriesCount>
        )}
      </WorkTitleContainer>
    );
  };

  const handleToggleOpen = (id: string) =>
    setOpen(open.id === id ? { id: "", show: false } : { id: id, show: true });

  return (
    <TableBody>
      {data.map((row, index) => {
        const isOpen = open.show && row.workTitleRowId === open.id;

        return (
          <Fragment key={"workHistoryTableRows-table-row-" + index}>
            <TableRow>
              <TableCell
                sx={{
                  borderBottom: "none",
                  padding: "0.5rem 0.5rem 0.5rem 0",
                  verticalAlign: "top",
                }}
                size="small"
              >
                <IconButton
                  sx={{ padding: 0 }}
                  onClick={() => handleToggleOpen(row.workTitleRowId)}
                >
                  {isOpen ? (
                    <KeyboardArrowDownIcon />
                  ) : (
                    <KeyboardArrowRightIcon />
                  )}
                </IconButton>
              </TableCell>
              <WorkTitleTableCell
                isOpen={isOpen}
                width="50%"
                size="small"
                sx={{ verticalAlign: "top" }}
              >
                {getWorkTitle(row)}
              </WorkTitleTableCell>
              <WorkTitleTableCell
                isOpen={isOpen}
                size="small"
                sx={{
                  padding: "0.5rem",
                  textAlign: "center",
                  verticalAlign: "top",
                }}
              >
                {getDateRange(row.startDate, row.endDate)}
              </WorkTitleTableCell>
              <WorkTitleTableCell isOpen={isOpen} width="25%" />
            </TableRow>
            <WorkTitleCollapsibleRows
              row={row}
              isOpen={isOpen}
              handleOpenEditModal={handleOpenEditModal}
              handleDelete={handleDelete}
              canEdit={canEdit}
            />
          </Fragment>
        );
      })}
    </TableBody>
  );
};

export default WorkHistoryTableRows;
